import { InfoElement } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { formatValidNumber, getPercentDifference, handleNullCase } from 'utils'

const Traffic = ({ trafficCurrent, trafficCompared, trafficMax }) => {
  const current = formatValidNumber(trafficCurrent)
  const compared = handleNullCase(formatValidNumber(trafficCompared))
  const progress = (trafficCurrent * 100) / trafficMax

  return (
    <div className="store-result-compare">
      <div>
        <b>{current} /</b> {compared}
        <div className="progress-wrapper">
          <span className="progress-line" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <InfoElement percentDifference={getPercentDifference(trafficCompared, trafficCurrent, 2, true)} />
    </div>
  )
}

Traffic.propTypes = {
  trafficCompared: PropTypes.number,
  trafficCurrent: PropTypes.number,
  trafficMax: PropTypes.number,
}

export default Traffic
